//https://reactjs.org/docs/faq-functions.html
import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import { NavLink } from "react-router-dom";
import {
  Row,
  Col,
  Progress,
  Card,
  CardBody,
  CardHeader,
  Table,
  Form,
  FormText,
  FormGroup,
  Label,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import AuthService from "../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import Edit from "@material-ui/icons/Edit";
import Tables from "../Base/Tables/Tables";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
//import FR from 'date-fns/locale/FR';
import "react-datepicker/dist/react-datepicker.css";

class AdminCompanies extends Component {
    constructor(props) {
      super(props);
      this.Auth = new AuthService();
      this.state = {
        modal: false,
        modalEdit: false,
        idCompanyEdit: "",
        data: [],
        offset: 0,
        isLoading: false,
        name: '',
        code: '',
        endOfAccessAt: '',
        endOfAccessAtMysql : '',
        /* pour le changement d'image */
        modalImage: false,
        file: '',
        imagePreviewUrl: ''
      };
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleSubmitImageModal = this.handleSubmitImageModal.bind(this);
      this.handleSubmitEditModal = this.handleSubmitEditModal.bind(this);
      this.perPage = 20;
      this.handlePageClick = this.handlePageClick.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this._handleImageChange = this._handleImageChange.bind(this);
      this.toggle = this.toggle.bind(this);
      this.toggleEditModal = this.toggleEditModal.bind(this);
      this.delete = this.delete.bind(this);
      this.editImage = this.editImage.bind(this);
      this.edit = this.edit.bind(this);

      this.toggleImageModal = this.toggleImageModal.bind(this);
    }

    //  pour l'affichage des messages d'erreurs
    notifyError(err) {
      toast.error(err);
    }

    //  pour l'affichage des messages de success
    notifySuccess(msg) {
      toast.success(msg);
    }

    //  pour l'affichage des messages d'erreurs
    notifyInfo(err) {
      toast.info(err);
    }

    componentDidMount() {
      this.fetchCompanies(this);
    }

    componentDidUpdate(prevProps) {
      if (prevProps.newFetch !== this.props.newFetch) {
        this.fetchCompanies(this);
        this.forceUpdate();
      }
    }

    // récuperation de la pagination
    handlePageClick(data) {
      let selected = data.selected;
      let offset = Math.ceil(selected * this.perPage);

      this.setState({
        offset: offset
      }, () => {
        this.fetchCompanies(this);
      });
    }

    toggle() {
      this.setState(prevState => ({
        modal: !prevState.modal
      }));
    }

    /**
     * Alexandre Vasseur
     * Ouverture et fermeture du modal d'édition
     */
    toggleEditModal() {
      this.setState(prevState => ({
        modalEdit: !prevState.modalEdit

      }));
    }


    /**
     * Alexandre Vasseur
     * Ouverture et fermeture du modal d'ajout de photo
     */
    toggleImageModal() {
      this.setState(prevState => ({
        modalImage: !prevState.modalImage
      }));
    }


    //**********************************************************************************
    //  Fonction de suppression d'une companie
    //**********************************************************************************
    delete(event) {

      // récuperation de la valeur de l'id à supprimer
      let idToDelete = event.currentTarget.getAttribute('data-id');
      //let companyNameToDelete = event.currentTarget.value;


      //  message de confirmation
      if (confirm("Etes-vous sur de bien vouloir supprimer l'id : " + idToDelete)) {
        //  passage à l'état isLoading
        this.setState({
          isLoading: true
        });

        //  envoie de la requete
        this.Auth.httpRequest("post", "api/company/deleteAdmin", {
            companyId: idToDelete
          })
          .then(datas => {
            datas = datas.data;
            var msg = "La company a été supprimé avec succès";
            this.notifySuccess(msg);
            this.setState({
              isLoading: false,
              modal: false
            });
          })
          .catch(error => {
            console.log(error);
            this.notifyError("Erreur de suppression de la compagnie");
          })
          .finally(() => {
            this.fetchCompanies(this);
          });
      }


      //  on soumet pas vraiment le formulaire
      event.preventDefault();
    }


    /**
     * Alexandre Vasseur
     * Lien d'ouverte d'ajout de photo
     */
    editImage(event) {
        // récuperation de la valeur de l'id à supprimer
        let idCompany = event.currentTarget.getAttribute('data-id');

      this.setState({
        idCompanyImage: event.currentTarget.getAttribute("data-id"),
        nameCompanyImage: event.currentTarget.getAttribute("data-title")
      });
      this.toggleImageModal();
      event.preventDefault();
    }

    /**
     * Alexandre Vasseur
     * Edition d'une company
     */
    edit(event) {
      this.setState({
        idCompanyEdit: event.currentTarget.getAttribute("data-id"),
        name: event.currentTarget.getAttribute("data-name"),
        code: event.currentTarget.getAttribute("data-companycode"),
        endOfAccessAt : (event.currentTarget.getAttribute("data-endofaccessat")*1000)
      });
      this.toggleEditModal();
      event.preventDefault();
    }

    // récuperation des companies
    fetchCompanies(thus) {
      let url = this.props.id ? "/" + this.props.id : "";
      this.setState({
        isLoading: true
      });
      this.Auth.httpRequest(
          "GET",
          "api/company/selectCompanies" +
          url +
          "?limit=" +
          this.perPage +
          "&offset=" +
          this.state.offset
        )
        .then(function(datas) {
          if (
            !Array.isArray(datas.data) ||
            (Array.isArray(datas.data) && datas.data.length < 1)
          ) {
            thus.setState({
              data: [],
              pageCount: 0
            });
            return;
          }
          thus.Auth.httpRequest(
              "GET",
              "api/company/count/selectCompanies" +
              url
            )
            .then(function(count) {
              if (thus.state.pageCount && thus.state.pageCount != 0) {
                thus.setState({
                  data: datas.data
                });
              } else {
                thus.setState({
                  data: datas.data,
                  pageCount: Math.ceil(count.data[0].count / datas.data.length)
                });
              }
              thus.setState({
                isLoading: false
              });
            })
            .catch(error => thus.setState({
              isLoading: false
            }));
        })
        .catch(error => thus.setState({
          isLoading: false
        }));
    }


    /* change de l'image file upload */
    /* alexandre Vasseur */
    _handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({ file: file, imagePreviewUrl: reader.result });
        }

        if (file) {
            reader.readAsDataURL(file);
        }
    }



    /**
     * Alexandre Vasseur
     * Action lorsqu'on a cliquer sur le submit du modal de la photo
     */
    handleSubmitImageModal(event) {

        let formData = new FormData();
        formData.append("picture", this.state.file, this.state.file.name);
        formData.append("companyId", this.state.idCompanyImage);

        this.Auth.httpRequest("POST", "api/company/uploadPicture", formData)
            .then(datas => {
              var msg = "L'ajout du logo pour le monde a été réalisée avec succès";
              this.notifySuccess(msg);
              this.setState({
                modalImage: false,
                file: "",
                imagePreviewUrl: ''
              });
            })
            .catch(error => {
              this.notifyError("Erreur de l'ajout de logo pour le monde");
            })
            .finally(() => {
              this.fetchCompanies(this);
            });
          event.preventDefault();
    }


    //  récuperer le changement sur chaque champs
    handleChange(e, date = null) {
    //  cas particulier du date picker qui envoie la date en premiere params et l'objet event en second
        if(date != null) {
            this.setState({
                endOfAccessAt: e
            })
        } else {
          this.setState({
            [e.target.name]: e.target.value
          });
        }
    }

    // Action lorsqu'on a cliquer sur le submit
    // Préparation du tableau formater pour passer la requete à l'API
    handleSubmit(event) {
        //  on défini l'état en chargement
        this.setState({
          isLoading: true
        });

        //  modif de la date pour etre sur la bonne timeZone, sinon date avec un jour de -
        let tempEndDate = this.state.endOfAccessAt;
        tempEndDate.setHours(0, -tempEndDate.getTimezoneOffset(), 0, 0);
        this.state.endOfAccessAtMysql = tempEndDate.toISOString().slice(0, 10);

        // Ajout d'une company
        this.Auth.httpRequest("post", "api/company/insert", {
            name: this.state.name,
            code: this.state.code,
            endOfAccessAt: this.state.endOfAccessAtMysql
          })
          .then(datas => {
              console.log(datas);
              datas = datas.data;
              var msg = "L'ajout de la company a été réalisé avec succès";
              this.notifySuccess(msg);
              this.setState({
                  isLoading: false,
                  modal: false,
                  name: '',
                  code: '',
                  endOfAccessAt: ''
              });
          })
      .catch(error => {
        console.log(error);
        this.notifyError("Erreur d'insertion de la compagnie");
      })
      .finally(() => {
        this.fetchCompanies(this);
      });



    //  on soumet pas vraiment le formulaire
        event.preventDefault();
    }

    // Action lorsqu'on a cliquer sur le submit d'editer
    // Préparation du tableau formater pour passer la requete à l'API
    handleSubmitEditModal(event) {
        //  on défini l'état en chargement
        this.setState({
          isLoading: true
        });

        //  modif de la date pour etre sur la bonne timeZone, sinon date avec un jour de -
        let tempEndDate = this.state.endOfAccessAt;
        tempEndDate.setHours(0, -tempEndDate.getTimezoneOffset(), 0, 0);
        this.state.endOfAccessAtMysql = tempEndDate.toISOString().slice(0, 10);


        // Ajout d'une company
        this.Auth.httpRequest("post", "api/company/update", {
            name: this.state.name,
            code: this.state.code,
            endOfAccessAt: this.state.endOfAccessAt,
            companyId: this.state.idCompanyEdit,
          })
          .then(datas => {
              datas = datas.data;
              var msg = "L'édition de la company a été réalisé avec succès";
              this.notifySuccess(msg);
              this.setState({
                  isLoading: false,
                  modalEdit: false,
                  name: '',
                  code: '',
                  endOfAccessAt: '',
                  idCompanyEdit:''
              });
          })
      .catch(error => {
        console.log(error);
        this.notifyError("Erreur d'édition de la compagnie");
      })
      .finally(() => {
        this.fetchCompanies(this);
      });



    //  on soumet pas vraiment le formulaire
        event.preventDefault();
    }


  render() {
    let content, tableCompanies, loading, addCompanyModal, editCompanyModal, addImageCompanyModal;

    if (this.state.isLoading) {
      loading = <img src="/img/loading_icon.gif" style={{ height: 'auto', width: 'auto', maxWidth: 70 + 'px', maxHeight: 70 + 'px' }} />
    }


    let {imagePreviewUrl} = this.state;
    let $imagePreview = null;

    let linkAddLogo = '';



    content = (
        <CardBody className="pb-0">
            <ToastContainer />
            <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nom</th>
                    <th>Code</th>
                    <th>Fin d'accès</th>
                    <th>Logo</th>
                    <th>Mondes</th>
                    <th>Éditer</th>
                    <th>Supprimer</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data && this.state.data.length > 0 ? (
                    this.state.data.map((object, index) => {
                        object.urlImg = API_URL + '/uploads/' + object.picture;

                      return (
                        <tr key={index}>
                          <td>{object.id}</td>
                          <td>{object.name}</td>
                          <td>{object.companyCode}</td>
                          <td>{object.endOfAccessAt}</td>
                          <td>{object.picture != null && <a href={'https://api.happyquest.co/uploads/' + object.picture} target="_blank">https://api.happyquest.co/uploads/{object.picture}</a>} <a href="#" onClick={this.editImage} data-id={object.id}><i className="fa fa-upload" /></a></td>
                          <td>
                          <NavLink
                            exact
                            to={"/admin/CompanyWorlds/" + object.id}
                          >
                            Editer les mondes
                          </NavLink>
                          </td>
                          <td>
                              <a
                                href="#"
                                onClick={this.edit}
                                data-id={object.id}
                                data-name={object.name}
                                data-companycode={object.companyCode}
                                data-endofaccessat={object.endOfAccessAtUnix}
                              >
                                <Edit />
                              </a>
                          </td>
                          <td><a href="#" onClick={this.delete} data-title={object.name} data-id={object.id}><i className="fa fa-trash text-danger" /></a></td>
                        </tr>
                      );
                    })
                  ) : (
                      <tr>
                        <td />
                        <td />
                      </tr>
                    )}
                </tbody>
                </Table>
                <ReactPaginate
                previousLabel={"Précédent"}
                nextLabel={"Suivant"}
                breakLabel={<a href="">...</a>}
                breakClassName={"break-me"}
                pageCount={this.state.pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                />
                {loading}
        </CardBody>
    );


    addCompanyModal = (
        <div>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className="addCompanyModal">
              <form onSubmit={this.handleSubmit}>
                  <ModalHeader toggle={this.toggle}>Nouvelle company</ModalHeader>
                    <ModalBody>
                        <div class="form-group">
                            <label htmlFor="name" className="col-form-label">
                              Nom:
                            </label>
                            <input required type="text" class="form-control" id="name" name="name" value={this.state.name} onChange={this.handleChange}/>
                        </div>
                        <div class="form-group">
                          <label htmlFor="code" className="col-form-label">Code:</label>
                          <input required type="text" class="form-control" id="code" name="code" value={this.state.code} onChange={this.handleChange}/>
                        </div>
                        <div class="form-group">
                          <label htmlFor="endOfAccessAt" className="col-form-label">Date de fin d'accès:</label>
                          <DatePicker
                              id="endOfAccessAt"
                              required
                              placeholderText="Date de fin d'accès"
                              className="form-control"
                              selected={this.state.endOfAccessAt}
                              dateFormat="dd/MM/yyyy"
                              onChange={this.handleChange}
                              placeholderText="Choisissez la date"
                          />
                        </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">Ajouter</Button>{' '}
                    <Button color="secondary" onClick={this.toggle}>Annuler</Button>
                  </ModalFooter>
                </form>
            </Modal>
        </div>
    );

    editCompanyModal = (
        <div>
            <Modal isOpen={this.state.modalEdit} toggle={this.toggleEditModal} className="editCompanyModal">
              <form onSubmit={this.handleSubmitEditModal}>
                  <ModalHeader toggle={this.toggleEditModal}>Modifier une compagnie</ModalHeader>
                    <ModalBody>
                        <div class="form-group">
                            <label htmlFor="name" className="col-form-label">
                              Nom:
                            </label>
                            <input required type="text" className="form-control" id="name" name="name" value={this.state.name} onChange={this.handleChange}/>
                        </div>
                        <div class="form-group">
                          <label htmlFor="code" className="col-form-label">Code:</label>
                          <input required type="text" class="form-control" id="code" name="code" value={this.state.code} onChange={this.handleChange}/>
                        </div>
                        <div class="form-group">
                          <label htmlFor="endOfAccessAt" className="col-form-label">Date de fin d'accès:</label>
                          <DatePicker
                              id="endOfAccessAt"
                              required
                              placeholderText="Date de fin d'accès"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={this.state.endOfAccessAt}
                              onChange={this.handleChange}
                              placeholderText="Choisissez la date"
                          />
                        </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">Ajouter</Button>{' '}
                    <Button color="secondary" onClick={this.toggleEditModal}>Annuler</Button>
                  </ModalFooter>
                </form>
            </Modal>
        </div>
    );

    addImageCompanyModal = (
        <div>
            <Modal isOpen={this.state.modalImage} toggle={this.toggleImageModal} className="imageModal">
              <form onSubmit={this.handleSubmitImageModal}>
                  <ModalHeader toggle={this.toggleImageModal}>Logo pour la company</ModalHeader>
                        <ModalBody>
                            <div>
                              <h2>{this.state.nameCompanyImage}</h2>
                            </div>
                            <FormGroup>
                                <Label htmlFor="exampleFile">Logo</Label>
                                <Input type="file" name="file" id="exampleFile" onChange={this._handleImageChange} />
                                <FormText color="muted">
                                  Logo à envoyer, pas trop gros, 400x400 maxi
                                </FormText>
                            </FormGroup>
                            {!$imagePreview && <img src={imagePreviewUrl} style={{ height: 'auto', width: 'auto', maxWidth: 200 + 'px',  }} />}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" type="submit">Envoyer</Button>{' '}
                            <Button color="secondary" onClick={this.toggleImageModal}>Annuler</Button>
                        </ModalFooter>
                </form>
            </Modal>
        </div>
    );

    return (
      <div>
          <div className="animated fadeIn">
            <br />
            <Row>
              <Col xs="12" lg="12">
                <Card>
                  <CardHeader>
                    <i className="fa fa-align-justify" /> Companies
                    <Button className="pull-right" color="primary" onClick={this.toggle}><i className="fa fa-plus" /> Ajouter</Button>
                  </CardHeader>
                  {content}

                </Card>
              </Col>
            </Row>
          </div>
          {addCompanyModal}
          {addImageCompanyModal}
          {editCompanyModal}
      </div>

    );
  }
}

export default AdminCompanies;



// WEBPACK FOOTER //
// ./src/views/AdminCompanies/AdminCompanies.js